<div class="container">
  @if (!showImageViewer) {
    @if (loading$ | async) {
      <div class="loading">
        <mat-spinner diameter="60"></mat-spinner>
        <div class="loading-text">Loading photos...</div>
      </div>
    } @else if (error$ | async; as error) {
      <div class="error-state">
        <mat-icon>error_outline</mat-icon>
        <div>Unable to load photos</div>
        <div class="error-detail">{{ error }}</div>
      </div>
    } @else if (layoutImages.length > 0) {
      <div class="header-bar">
        <span class="title">Media Library</span>
        <span class="count">{{ originalImages.length }} {{ originalImages.length === 1 ? 'photo' : 'photos' }}</span>
      </div>
      <div class="images-grid">
        @for (item of layoutImages; track item.image.id; let i = $index) {
          <div
            class="photo"
            [class.active]="i === activeIndex"
            [style.width.px]="item.width"
            [style.height.px]="item.height"
            [attr.data-photo-index]="i"
          >
            <img
              [src]="item.image.large_url || item.image.original_url"
              [class.loaded]="item.loaded"
              (load)="onImageLoaded(i)"
              alt=""
            />
          </div>
        }
      </div>
    } @else {
      <div class="empty-state">
        <mat-icon>photo_library</mat-icon>
        <div class="empty-title">No photos yet</div>
        <div class="empty-subtitle">Photos shared by family will appear here</div>
        <div class="empty-hint">Press back button to exit</div>
      </div>
    }
  }

  @if (showImageViewer) {
    <div class="viewer-overlay" [class.visible]="viewerVisible">
      <cm-image-viewer
        [images]="originalImages"
        [currentImage]="currentImage"
        (backPressed)="onBackPressed($event)"
      ></cm-image-viewer>
    </div>
  }
</div>
